import { createContext, useContext, useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const ThemeCtx = createContext(null);

const initial = () => localStorage.getItem("nv_theme") || (window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark");

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(initial);
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("light", theme === "light");
    root.classList.toggle("dark", theme === "dark");
    localStorage.setItem("nv_theme", theme);
  }, [theme]);
  const toggle = () => setTheme((t) => (t === "light" ? "dark" : "light"));
  return <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  const Icon = theme === "light" ? Moon : Sun;
  return (
    <button data-testid="theme-toggle-btn" onClick={toggle} aria-label={theme === "light" ? "Tema scuro" : "Tema chiaro"}
      title={theme === "light" ? "Passa al tema scuro" : "Passa al tema chiaro"}
      className="nv-press h-14 w-14 grid place-items-center rounded-xl bg-[#161e2e] border border-[#243047]">
      <Icon className="h-7 w-7 text-[#ef0298]" />
    </button>
  );
};
